import * as types from "./siteTypes";

//FOR FETCHING SITES
export const fetchSiteRequest = () => (
    {
    type: types.FETCH_SITE_REQUEST,
});

export const fetchSiteSuccess = (data) => ({
    type: types.FETCH_SITE_SUCCESS,
    payload: data,
});

export const fetchSiteFailure = (error) => ({
    type: types.FETCH_SITE_FAILURE,
    payload: error,
});


//FOR ADDING SITES
export const addSiteRequest = (data) => ({
    type: types.ADD_SITE_REQUEST,
    payload: data,
  });
  
  export const addSiteSuccess = (data) => ({
    type: types.ADD_SITE_SUCCESS,
    payload: data,
  });
  
  export const addSiteFailure = (error) => ({
    type: types.ADD_SITE_FAILURE,
    payload: error,
  });


//FOR UPDATING SITES
export const updateSiteRequest = (updatedSite) => ({
    type: types.UPDATE_SITE_REQUEST,
    payload: updatedSite,
});

export const updateSiteSuccess = (updatedSite) => ({
    type: types.UPDATE_SITE_SUCCESS,
    payload: updatedSite,
});

export const updateSiteFailure = (error) => ({
    type: types.UPDATE_SITE_FAILURE,
    payload: error,
});


//FOR DELETING SITES
export const deleteSiteRequest = (site,id ) => (
    ////console.log(id),
    {
    type: types.DELETE_SITE_REQUEST,
    payload: site,
});

export const deleteSiteSuccess = (id) => (
    ////console.log(id),
    {
    type: types.DELETE_SITE_SUCCESS,
    payload: id,
});

export const deleteSiteFailure = (error) => ({
    type: types.DELETE_SITE_FAILURE,
    payload: error,
});
